import { requestGet } from '@/common/request';

export interface Query {
  inventoryId: string;
  activityId: string;
}

interface TypeRuleDetails {
  type: 1 | 2 | 3 | 4;
  value: string[];
}

type ChangedType = 'ruleDetails' | 'addRuleDetails' | 'updateRuleDetails' | 'deleteRuleDetails';

interface TypeRules {
  ruleId: string;
  ruleName: string;
  // 这个字段是前端自己计算的，接口文档中没有
  operateType?: 1 | 2 | 3;
  ruleDetails?: TypeRuleDetails[];
  addRuleDetails?: TypeRuleDetails[];
  updateRuleDetails?: TypeRuleDetails[];
  deleteRuleDetails?: TypeRuleDetails[];
}

interface SubStrategies {
  subStrategyId: string;
  subStrategyName: string;
  rules: TypeRules[];
}

interface InveNeedConfirmRule {
  originalRule: {
    id: number;
    operatedTime?: number;
    updateTime?: number;
    operateType?: 1 | 2 | 3;
    subStrategies: SubStrategies[];
  };
  updateRules: {
    id: number;
    updateTime?: number;
    operatedTime?: number;
    operateType?: 1 | 2 | 3;
    subStrategies: SubStrategies[];
  }[];
}

//品类盘货 - 接收、驳回或移除盘货，规则变更确认
export async function queryInveNeedConfirmRule(params: Query): Promise<RequestResult<InveNeedConfirmRule>> {
  const res = await requestGet('/goodsPool/queryInveNeedConfirmRule', params);
  if (res.ret !== '0') return res;
  if (!res.data) return res;

  // 会对数据进行修改
  transformRes(res.data);

  return res;
}

// 计算规则的operateType
function transformRes(data: any) {
  try {
    // 遍历更新记录
    data.updateRules.forEach((updateHistoryItem: any) => {
      const strategyOperateType = updateHistoryItem.operateType;

      // 遍历更新记录中的子策略
      // 1添加 2 修改 3删除
      updateHistoryItem.subStrategies.forEach((subStrategy: SubStrategies) => {
        subStrategy.rules.forEach((ruleItem: TypeRules) => {
          // Bi案例子策略中的每个规则
          // 1新增 2 修改 3 删除
          ruleItem.operateType = strategyOperateType;
        });
      });
    });
  } catch (ex) {
    console.error(ex);
  }
}
// // 策略新增 + 只有标签新增 = 规则组新增
// // 策略变动 + 只有标签删除 = 规则组删除
// function computedRuleOperateType(strategyOperateType: 1 | 2 | 3, ruleItem: TypeRules) {
//   if (strategyOperateType === 1) {
//     if (
//       ruleItem.addRuleDetails &&
//       ruleItem.addRuleDetails.length > 0 &&
//       !ruleItem.deleteRuleDetails &&
//       !ruleItem.updateRuleDetails
//     )
//       return 1;
//   } else if (strategyOperateType === 3) {
//     if (
//       ruleItem.deleteRuleDetails &&
//       ruleItem.deleteRuleDetails.length > 0 &&
//       !ruleItem.addRuleDetails &&
//       !ruleItem.updateRuleDetails
//     )
//       return 3;
//   }

//   return 2;
// }

export type { ChangedType, InveNeedConfirmRule, TypeRuleDetails, TypeRules };
